var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterTwoC4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.84375C16.5142 5.84318 17.268 6.02083 17.9515 6.36259C18.635 6.70435 19.2294 7.2008 19.6875 7.8125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 7.8125C1.77056 7.2008 2.36496 6.70435 3.04848 6.36259C3.732 6.02083 4.4858 5.84318 5.25 5.84375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.0938C12.3122 11.0938 13.7812 9.62468 13.7812 7.8125C13.7812 6.00032 12.3122 4.53125 10.5 4.53125C8.68782 4.53125 7.21875 6.00032 7.21875 7.8125C7.21875 9.62468 8.68782 11.0938 10.5 11.0938Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 13.7188C6.37735 12.9193 7.04891 12.2567 7.85457 11.7963C8.66023 11.3359 9.57208 11.0938 10.5 11.0938C11.4279 11.0938 12.3398 11.3359 13.1454 11.7963C13.9511 12.2567 14.6227 12.9193 15.0938 13.7188",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.207 2.5625C13.3298 2.08718 13.5833 1.6558 13.9389 1.31735C14.2945 0.978899 14.7378 0.746941 15.2186 0.647819C15.6994 0.548696 16.1984 0.586382 16.6589 0.756596C17.1193 0.926809 17.5228 1.22273 17.8235 1.61075C18.1242 1.99877 18.3101 2.46334 18.3601 2.9517C18.41 3.44006 18.322 3.93264 18.106 4.3735C17.8901 4.81435 17.5548 5.18582 17.1384 5.44571C16.7219 5.7056 16.2409 5.8435 15.75 5.84375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25063 5.84375C4.75972 5.8435 4.27872 5.7056 3.86225 5.44571C3.44578 5.18582 3.11054 4.81435 2.89459 4.3735C2.67863 3.93264 2.59063 3.44006 2.64057 2.9517C2.69052 2.46334 2.8764 1.99877 3.17711 1.61075C3.47783 1.22273 3.88133 0.926809 4.34178 0.756596C4.80223 0.586382 5.30119 0.548696 5.78199 0.647819C6.26278 0.746941 6.70615 0.978899 7.06173 1.31735C7.41732 1.6558 7.67087 2.08718 7.7936 2.5625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwoC4);
export default __webpack_public_path__ + "static/media/footer-two-c-4.d4e3271467b4826af97d50295f9d4968.svg";
export { ForwardRef as ReactComponent };